import * as types from 'actions/terms/types';

const initialState = {
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET:
      return { ...state, data: action.payload };
    default:
      return state;
  }
};
